import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/*
 * EmptyState — DESIGN_SYSTEM.md §2.4
 * Centered title + sub + optional outline action button.
 * Used in list pages, search results, slot grids.
 */

interface EmptyStateProps {
  /** Lucide icon component or any visual element. Rendered ~48px above the title. */
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
  /** When true, halves vertical padding for use inside compact lists. */
  compact?: boolean;
}

export function EmptyState({ icon, title, description, action, className, compact }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center',
        compact ? 'py-8' : 'py-16',
        className,
      )}
    >
      {icon && (
        <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-pill bg-surface-2 text-soft [&_svg]:h-6 [&_svg]:w-6">
          {icon}
        </div>
      )}
      <h3 className="text-h4 text-ink">{title}</h3>
      {description && (
        <p className="mt-1.5 max-w-sm text-body-sm text-soft">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
